import { fillRouteWithSlugs } from "@utils";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import { ROUTE_SLUGS, ROUTES } from "src/config/navigation/routes";
import { ChangeManagementPlanRecord } from "src/types/change-management";
import {
  formatPlanDate,
  getImpactDisplay,
  getPlanTitle,
} from "./change-management-plan";
import { PlanStatus } from "./PlanStatus";

const rowClassName =
  "grid min-w-[720px] grid-cols-[minmax(0,1fr)_120px_120px_90px_110px_16px] items-center gap-4 border-0 border-b border-solid border-black/[.12] px-4 last:border-b-0";

const PlanRunRow = ({
  orgId,
  record,
}: {
  orgId: string;
  record: ChangeManagementPlanRecord;
}) => (
  <Link
    to={fillRouteWithSlugs(ROUTES.CHANGE_MANAGEMENT_PLAN, {
      [ROUTE_SLUGS.ORG_ID]: orgId,
      [ROUTE_SLUGS.PLAN_ID]: record.id,
    })}
    className={`${rowClassName} min-h-[52px] text-black/[.87] no-underline transition-colors hover:bg-black/[.04]`}
  >
    <span className="truncate font-semibold">{getPlanTitle(record.plan)}</span>
    <span className="whitespace-nowrap">
      {getImpactDisplay(record.plan.summary.impact.level).label}
    </span>
    <span>
      <PlanStatus status={record.plan.status} />
    </span>
    <span className="text-black/60">{record.plan.recommendations.length}</span>
    <span className="text-black/60">{formatPlanDate(record.createdAt)}</span>
    <ChevronRight size={16} className="text-gray-500" />
  </Link>
);

export const PlanRunsTable = ({
  orgId,
  records,
}: {
  orgId: string;
  records: ChangeManagementPlanRecord[];
}) => (
  <section
    aria-label="Change management runs"
    className="overflow-x-auto rounded border border-solid border-black/[.12] bg-white"
  >
    <div
      aria-hidden="true"
      className={`${rowClassName} min-h-10 text-sm font-semibold text-black/60`}
    >
      <div>Change</div>
      <div>Impact</div>
      <div>Status</div>
      <div>Documents</div>
      <div>Created</div>
      <div />
    </div>
    {records.map((record) => (
      <PlanRunRow key={record.id} orgId={orgId} record={record} />
    ))}
  </section>
);
